import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.STATUS_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.STATUS_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const statusList = () => {
  return async (dispatch) => {
    dispatch({ type: CONST.STATUS_LIST_REQUEST });

    axios
      .get('/statuses')
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
